import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { Input } from "../../../../library/input";
import { sendErrorNotification } from "../../../../universal/notifications/notifications";
import {
  changeListsModal,
  requestUpdateList,
  resetActiveListDisplay,
} from "../../../../../redux/actions/lists";
import { TransparentButton, SolidButton } from "../../../../library/button";
import { Popup } from "../../../../library/popup";
import { Label } from "../../../../library/label";
import { ToastContainer } from "react-toastify";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();
  const modalState = useSelector((state) => state.lists.showModals.editModal);
  const activeList = useSelector((state) => state.lists.activeList);
  const companyId = useSelector(
    (state) => state.activeCompany.activeCompany.id
  );

  const updateLoading = useSelector((state) => state.lists.updateList.loading);

  const [activeEdit, setActiveEdit] = useState({
    name: null,
    key: null,
  });

  const handleClose = () => {
    dispatch(changeListsModal({ editModal: false }));
    dispatch(resetActiveListDisplay());
  };

  const clickUpdateClient = () => {
    if (activeEdit.name !== "") {
      dispatch(requestUpdateList({ companyId: companyId, list: activeEdit }));
    } else {
      sendErrorNotification("Vennligst fyll inn et navn.");
    }
  };

  useEffect(() => {
    if (activeEdit.name === null && activeEdit.key === null) {
      setActiveEdit({ name: activeList.name, id: activeList.id });
    }
  });

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Endre eksisterende liste"
      buttons={[
        <TransparentButton
          title="Avbryt"
          id="closeButtonAdd"
          type="button"
          data-dismiss="modal"
          onClick={() => handleClose()}
        />,
        <SolidButton
          color="blue"
          title={updateLoading ? "Oppdaterer.." : "Oppdater"}
          icon={
            updateLoading ? (
              <i className="fas fa-circle-notch fa-spin"></i>
            ) : (
              <i className="fas fa-sync"></i>
            )
          }
          onClick={() => clickUpdateClient()}
          type="button"
        />,
      ]}
    >
      <div className="edit-list-popup-content">
        <Row className="info-row">
          <Col className="info-col">
            <Label version={1} weight="bold">
              Navn
            </Label>
            <Input
              value={activeEdit ? activeEdit.name : null}
              onChange={(e) =>
                setActiveEdit({ ...activeEdit, name: e.target.value })
              }
              placeholder="Skriv inn et navn"
              type="text"
            />
          </Col>
        </Row>
      </div>
      <ToastContainer />
    </Popup>
  );
};

export default Index;
